import script from "./FormGroup.vue?vue&type=script&lang=ts"
export * from "./FormGroup.vue?vue&type=script&lang=ts"

import "./FormGroup.vue?vue&type=style&index=0&id=66cbcc2a&lang=scss&scoped=true"

import exportComponent from "/mnt/c/Users/mssuzuki/work/fidev/nicotto/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66cbcc2a"]])

export default __exports__